var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"-40px"}},[_c('graficodoughnut',{attrs:{"rotulo":'DETALHES:',"legendas":_vm.legendasgrupospro,"dados":_vm.dadosgrupospro}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }